import { captureException } from '@sentry/react';
import type { Extras } from '@sentry/types';

export enum ErrorType {
  GraphQLError = 'GraphQLError',
}

/**
 * A function to log errors to Sentry with additional context.
 * @param error
 * @param errorType
 * @param extra
 */
export function logToSentry(error: Error, errorType: ErrorType, extra?: Extras) {
  captureException(error, {
    tags: {
      feature: 'TeamsV2',
      errorType,
    },
    extra,
  });
}
